<template>
<div class="col backgroundForm">
    <h5 align="center">Cuadro de Registro de Niveles de Rios</h5>
    <div class="input-group mb-3 col-12 col-md-6 offset-md-3">
        <input type="date" class="form-control" placeholder="Fecha de Registros" aria-describedby="basic-addon2" v-model="date_search">
        <div class="input-group-append">
            <button class="btn btn-outline-success" type="button" @click="mLlamaCuadroRios('cf')">A la Fecha</button>
        </div>
        <div class="input-group-append">
            <button class="btn btn-outline-info" type="button" @click="mLlamaCuadroRios('sf')">Ultimo Registro</button>
        </div>
    </div>

    <br>
            <button class=" col-12 col-md-2 offset-md-8 btn btn-outline-primary" @click="mCopyToClipboard('printTable')" v-if="dts_lectura.length>0">
                <font-awesome-icon icon="copy" />copiar 
            </button>
    <div class="table-responsive" id="printTable">
        <table class="table table-sm table-hover" v-if="dts_lectura.length>0">
            <thead>
                <tr style="font-size: 12px;">
                    <th>#</th>
                    <th>CUENCA</th>
                    <th>LAGO/RIO</th>
                    <th>SECTOR</th>
                    <th>CAPITANIA RESPONSABLE</th>
                    <th>LECTURA</th>
                    <th>FECHA/CLIMA</th>
                    <th>LECTURA</th>
                    <th>ALERTA</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(dl, index) in dts_lectura" :key="dl.id" style="font-size: 12px;">
                    <td>{{ index+1 }}</td>
                    <td>{{ dl.basin }}</td>
                    <td>{{ dl.river_lake }}</td>
                    <td class="text-wrap" style="width: 15rem;">{{ dl.sector_river_lake }}</td>
                    <td>{{dl.responsable}}</td>
                    <td>{{dl.ccpp}} - {{ dl.usuario }}</td>
                    <td>{{ $dateWrite(dl.date_read) }} - {{ dl.clima }}</td>
                    <td>{{ dl.read_level }} ({{ dl.type_read }})</td>
                    <td><div :class="dl.alert"></div></td>
                </tr>
            </tbody>
        </table>
    </div>
    
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default{
    name:'reportDiario',
    data(){
        return {
            date_search:'',
            dts_lectura:[]
        }
    },
    methods: {
        mCopyToClipboard(elemento) {
            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
        },
        async mLlamaCuadroRios(tipo){
            this.dts_lectura=[];
            let nivelesRios=await axios.get(`getReadRivers/${this.date_search}/${tipo}?api_token=${Vue.auth.getToken()}`);
            console.log(nivelesRios);
            let aux_lc=nivelesRios.data;
            aux_lc.forEach((dt)=>{
                let aux_color;
                switch (dt.alert){
                    case 'A':
                        aux_color='puntoAmarillo';
                    break;

                    case 'N':
                        aux_color='puntoNaranja';
                    break;

                    case 'R':
                        aux_color='puntoRojo';
                    break;

                    case 'V':
                        aux_color='puntoVerde';
                    break;

                    default:
                        aux_color='puntoBlanco';
                    break;
                }
                let aux_lect={
                    basin:dt.basin,
                    river_lake:dt.river_lake,
                    sector_river_lake:dt.sector_river_lake,
                    responsable:dt.responsible,
                    // capitania:'S/R',
                    date_read:dt.date_read,
                    read_level:dt.read_level,
                    type_read:dt.type_read,
                    alert:aux_color,
                    ccpp:dt.ccpp,
                    clima:dt.clima,
                    usuario:dt.usuario
                }
                this.dts_lectura.push(aux_lect);
            });            
        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.date_search=date_aux;           
        },
    },
    mounted() {
        this.getToday();
    },
}
</script>

<style scoped>
@keyframes intermitente {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}

/* Estilos para el punto */
.puntoAmarillo {
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-color: rgb(147, 186, 186);
  background-color: yellow;
  border-radius: 50%;
  /* Aplicar la animación: nombre, duración, tipo, repetición */
  animation: intermitente 3s infinite;
}

.puntoVerde {
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-color: rgb(147, 186, 186);
  background-color: green;
  border-radius: 50%;
  /* Aplicar la animación: nombre, duración, tipo, repetición */
  animation: intermitente 3s infinite;
}

.puntoRojo {
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-color: rgb(147, 186, 186);
  background-color: red;
  border-radius: 50%;
  /* Aplicar la animación: nombre, duración, tipo, repetición */
  animation: intermitente 3s infinite;
}

.puntoNaranja {
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-color: rgb(147, 186, 186);
  background-color: orange;
  border-radius: 50%;
  /* Aplicar la animación: nombre, duración, tipo, repetición */
  animation: intermitente 3s infinite;
}

.puntoBlanco {
  width: 15px;
  height: 15px;
  border: 1px solid;
  border-color: rgb(147, 186, 186);
  background-color: white;
  border-radius: 50%;
  /* Aplicar la animación: nombre, duración, tipo, repetición */
  animation: intermitente 3s infinite;
}

</style>


// WEBPACK FOOTER //
// src/components/river/reportRiverDiario.vue